import { render, staticRenderFns } from "./CourseCenterForm.vue?vue&type=template&id=324a869c&scoped=true"
import script from "./CourseCenterForm.vue?vue&type=script&lang=js"
export * from "./CourseCenterForm.vue?vue&type=script&lang=js"
import style0 from "./CourseCenterForm.vue?vue&type=style&index=0&id=324a869c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324a869c",
  null
  
)

export default component.exports